import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { OnboardingFormFields } from '@Types/index';
import { ErrorType } from './errorType';
import type { IErrorHandling } from '@Types/index';

export enum KYCStatus {
  CHECKING = 'CHECKING',
  MORE_INFO_REQUIRED = 'MORE_INFO_REQUIRED',
  MORE_INFO_AUTO_REQUIRED = 'MORE_INFO_AUTO_REQUIRED',
  RESUBMIT_REQUIRED = 'RESUBMIT_REQUIRED',
  PARTNER_REVIEW = 'PARTNER_REVIEW',
  RESUBMIT_ADDRESS = 'RESUBMIT_ADDRESS',
  RESUBMIT_ADDRESS_PO_BOX = 'RESUBMIT_ADDRESS_PO_BOX',
  RESUBMIT_ADDRESS_UNADDRESSABLE = 'RESUBMIT_ADDRESS_UNADDRESSABLE',
  RESUBMIT_ADDRESS_PARTNER = 'RESUBMIT_ADDRESS_PARTNER',
  INVALID_KYC_DATA = 'INVALID_KYC_DATA',
  FAILED_KYC = 'FAILED_KYC',
  FAILED_KYC_NON_US_DOCV_PARTNER = 'FAILED_KYC_NON_US_DOCV_PARTNER',
  FAILED_KYC_RESUBMIT_ADDRESS_COMMERCIAL = 'FAILED_KYC_RESUBMIT_ADDRESS_COMMERCIAL',
  FAILED_KYC_RESUBMIT = 'FAILED_KYC_RESUBMIT',
  FAILED_KYC_RESUBMIT_ADDRESS = 'FAILED_KYC_RESUBMIT_ADDRESS',
  FAILED_KYC_RESUBMIT_ADDRESS_PO_BOX = 'FAILED_KYC_RESUBMIT_ADDRESS_PO_BOX',
  FAILED_KYC_RESUBMIT_ADDRESS_UNADDRESSABLE = 'FAILED_KYC_RESUBMIT_ADDRESS_UNADDRESSABLE',
  FAILED_KYC_RESUBMIT_ADDRESS_PARTNER = 'FAILED_KYC_RESUBMIT_ADDRESS_PARTNER',
}

export const KycErrorMap = {
  [KYCStatus.CHECKING]: { errorCode: 4307, errorType: ErrorType.BUSINESS_LOGIC },
  [KYCStatus.MORE_INFO_REQUIRED]: { errorCode: 4308, errorType: ErrorType.BUSINESS_LOGIC },
  [KYCStatus.MORE_INFO_AUTO_REQUIRED]: { errorCode: 4309, errorType: ErrorType.BUSINESS_LOGIC },
  [KYCStatus.RESUBMIT_REQUIRED]: { errorCode: 4317, errorType: ErrorType.BUSINESS_LOGIC },
  [KYCStatus.PARTNER_REVIEW]: { errorCode: 4318, errorType: ErrorType.BUSINESS_LOGIC },
  [KYCStatus.RESUBMIT_ADDRESS]: { errorCode: 43171, errorType: ErrorType.BUSINESS_LOGIC },
  [KYCStatus.RESUBMIT_ADDRESS_PO_BOX]: { errorCode: 43172, errorType: ErrorType.BUSINESS_LOGIC },
  [KYCStatus.RESUBMIT_ADDRESS_UNADDRESSABLE]: {
    errorCode: 43174,
    errorType: ErrorType.BUSINESS_LOGIC,
  },
  [KYCStatus.RESUBMIT_ADDRESS_PARTNER]: { errorCode: 43175, errorType: ErrorType.TECHNICAL },
  [KYCStatus.FAILED_KYC]: { errorCode: 4017, errorType: ErrorType.BUSINESS_LOGIC },
  [KYCStatus.INVALID_KYC_DATA]: { errorCode: 43071, errorType: ErrorType.BUSINESS_LOGIC },
  [KYCStatus.FAILED_KYC_NON_US_DOCV_PARTNER]: {
    errorCode: 43176,
    errorType: ErrorType.BUSINESS_LOGIC,
  },
  [KYCStatus.FAILED_KYC_RESUBMIT_ADDRESS_COMMERCIAL]: {
    errorCode: 43173,
    errorType: ErrorType.BUSINESS_LOGIC,
  },
  [KYCStatus.FAILED_KYC_RESUBMIT]: { errorCode: 4317, errorType: ErrorType.BUSINESS_LOGIC },
  [KYCStatus.FAILED_KYC_RESUBMIT_ADDRESS]: {
    errorCode: 43171,
    errorType: ErrorType.BUSINESS_LOGIC,
  },
  [KYCStatus.FAILED_KYC_RESUBMIT_ADDRESS_PO_BOX]: {
    errorCode: 43172,
    errorType: ErrorType.BUSINESS_LOGIC,
  },
  [KYCStatus.FAILED_KYC_RESUBMIT_ADDRESS_UNADDRESSABLE]: {
    errorCode: 43174,
    errorType: ErrorType.BUSINESS_LOGIC,
  },
  [KYCStatus.FAILED_KYC_RESUBMIT_ADDRESS_PARTNER]: {
    errorCode: 43175,
    errorType: ErrorType.BUSINESS_LOGIC,
  },
};

export const getKycErrorsObjectMap = (): Map<number, IErrorHandling> => {
  return new Map<number, IErrorHandling>([
    [
      KycErrorMap[KYCStatus.FAILED_KYC].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.FAILED_KYC].errorCode,
        redirectPath: routesModel[RoutesMap.KYC_FAILED].path,
        relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
        callBack: () => {},
      },
    ],
    [
      KycErrorMap[KYCStatus.CHECKING].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.CHECKING].errorCode,
        redirectPath: routesModel[RoutesMap.UNDER_REVIEW].path,
        relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
        callBack: () => {},
      },
    ],
    [
      KycErrorMap[KYCStatus.MORE_INFO_REQUIRED].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.MORE_INFO_REQUIRED].errorCode,
        redirectPath: routesModel[RoutesMap.NON_US_SOCURE].path,
        nonUserRedirectPath: routesModel[RoutesMap.NON_US_SOCURE].path,

        relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
        callBack: () => {},
      },
    ],
    [
      KycErrorMap[KYCStatus.MORE_INFO_AUTO_REQUIRED].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.MORE_INFO_AUTO_REQUIRED].errorCode,
        redirectPath: routesModel[RoutesMap.NON_US_SOCURE].path,
        nonUserRedirectPath: routesModel[RoutesMap.NON_US_SOCURE].path,
        relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
        callBack: () => {},
      },
    ],
    [
      KycErrorMap[KYCStatus.FAILED_KYC_NON_US_DOCV_PARTNER].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.FAILED_KYC_NON_US_DOCV_PARTNER].errorCode,
        redirectPath: routesModel[RoutesMap.KYB_PENDING].path,
        nonUserRedirectPath: routesModel[RoutesMap.KYB_PENDING].path,
      },
    ],
    [
      KycErrorMap[KYCStatus.RESUBMIT_REQUIRED].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.RESUBMIT_REQUIRED].errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.HOME_LINE_1,
        callBack: () => {},
      },
    ],
    [
      KycErrorMap[KYCStatus.PARTNER_REVIEW].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.PARTNER_REVIEW].errorCode,
        redirectPath: routesModel[RoutesMap.KYC_FAILED].path,
        relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
        callBack: () => {},
      },
    ],
    [
      KycErrorMap[KYCStatus.RESUBMIT_ADDRESS].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.RESUBMIT_ADDRESS].errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.HOME_LINE_1,
        callBack: () => {},
      },
    ],
    [
      KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_PO_BOX].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_PO_BOX].errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.HOME_LINE_1,
        callBack: () => {},
      },
    ],
    [
      KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_UNADDRESSABLE].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_UNADDRESSABLE].errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.HOME_LINE_1,
        callBack: () => {},
      },
    ],
    [
      KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_PARTNER].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_PARTNER].errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.HOME_LINE_1,
        callBack: () => {},
      },
    ],
    [
      KycErrorMap[KYCStatus.INVALID_KYC_DATA].errorCode,
      {
        errorCode: KycErrorMap[KYCStatus.INVALID_KYC_DATA].errorCode,
        redirectPath: routesModel[RoutesMap.NON_US_SOCURE].path,
        nonUserRedirectPath: routesModel[RoutesMap.NON_US_SOCURE].path,
        relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
        callBack: () => {},
      },
    ],
  ]);
};
